/* eslint-disable jsx-a11y/no-autofocus */
import { Button, createStyles, useMantineTheme } from '@mantine/core';
import { useNavigate } from 'react-router-dom';
import { useGetStep } from 'src/hooks';
import { ScreenWrapper } from '../../components';
import resumeImg from '../../assets/images/resume.webp';
import resumeImgDark from '../../assets/images/resumeDark.webp';
import { ReactComponent as RightArrow } from '../../assets/icons/right-arrow.svg';

const useStyles = createStyles((theme) => ({
  paddingTop0: {
    paddingTop: '0 !important',
  },
  cmodal: {
    width: '400px',
    background: 'yellow',
    '& > div': {
      width: '400px',
      background: 'red',
    },
  },
  banner: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    // backgroundColor: '#0C0C0C',
    color: '#ffffff',
    padding: '29px 0',
    gap: '24px',
    // background: 'linear-gradient(195.07deg, #9747FF 10.61%, #F2994A 80.32%)',
    // boxShadow: '0px 6px 13px 11px #000000',
    borderRadius: '12px',
  },
  bannerBottom: {
    marginLeft: 'auto',
    // width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '10px',
    gap: '10px',
    textAlign: 'center',
  },
  bannerDescription: {
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '18px',
    color: '#ffffff',
  },
  bannerImage: {
    margin: '4rem 0 2rem 0',
    height: '17rem',
    width: '100%',
  },
  contentContainer: {
    padding: '20px',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  bannerHeading: {
    color: theme.other.colors.fg.default,
  },
  button: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '10px 32px',
    background: '#ffffff',
    borderRadius: '5px',
    border: 'none',
    boxShadow: 'rgba(0, 0, 0, 0.35) 0px 5px 15px',
    backgroundColor: theme.other.colors.primaryOld,
    ':hover': {
      cursor: 'pointer',
    },
  },
}));

export const Home = () : JSX.Element => {
  const { classes } = useStyles();
  const navigate = useNavigate();
  const theme = useMantineTheme();
  const isDarkMode = theme.colorScheme === 'dark';
  const { onContinueAcOpening } = useGetStep();

  const handleRoute = () => {
    const step = onContinueAcOpening()
    navigate(step)
  }

  return (
    <ScreenWrapper>
      <div className={`csMainContainer ${classes.paddingTop0}`}>
        <div className={classes.contentContainer}>
          <div className={classes.banner}>
            <h2 className={`csHeading ${classes.bannerHeading}`}>
              Resume your Application
            </h2>
            <img src={isDarkMode ? resumeImgDark : resumeImg} className={classes.bannerImage} alt="banner_image" />
            <div className={classes.bannerBottom}>
              <Button
                rightIcon={<RightArrow />}
                radius={4}
                autoFocus
                type="button"
                onClick={handleRoute}
              >
                Continue
              </Button>
            </div>
          </div>
        </div>
      </div>
    </ScreenWrapper>

  );
};

export default Home;
